import React from "react";
import { useNavigate } from "react-router-dom";
import "../index.css";

function TermsOfServiceScreen() {
  const navigate = useNavigate();
  const contactEmailUser = "admin";
  const contactEmailDomain = "skywardinnovation.com";
  const contactEmail = `${contactEmailUser}@${contactEmailDomain}`;
  const contactHref = `mailto:${contactEmail}`;
  const handleContactClick = () => {
    window.location.href = contactHref;
  };

  const handleStartValuation = () => {
    navigate("/model-selection");
  };

  return (
    <div>
      {/* Header */}
      <header
        style={{
          backgroundColor: "#050d1a",
          padding: "20px",
          color: "#fff",
          textAlign: "center",
        }}
      >
        <h1>Terms of Service</h1>
      </header>

      {/* Main Content Section */}
      <section
        style={{
          padding: "100px",
          textAlign: "left",
          maxWidth: "800px",
          margin: "auto",
        }}
      >
        <h2>Last Updated: 29 September 2026</h2>
        <p style={{ fontSize: "0.9rem", margin: "1rem 0", color: "#666" }}>
          These Terms of Service (“Terms”) govern your use of the valuation tool
          and related Skyward Innovation services (“Service”) currently provided
          by <strong>DRPY Ltd, trading as Skyward Innovation</strong> (referred
          to as “we,” “us,” or “our”). By accessing or using the Service, you
          agree to be bound by these Terms. If you do not agree, you must not
          use the Service.
        </p>

        <h3>1. Service Provider</h3>
        <p style={{ fontSize: "0.9rem", color: "#666" }}>
          <strong>1.1 Current Service Provider</strong>
          <br />
          This MVP Service is currently owned and operated by{" "}
          <strong>DRPY Ltd, trading as Skyward Innovation</strong>. In future,
          the Service may be provided by a separate operating company or group
          entity. Any such change will be reflected in updated terms, but will
          not reduce your rights for Service use that occurred before the update.
          All communication regarding the Service must be directed to Skyward
          Innovation through the contact method below.
        </p>

        <h3>2. Informational Purposes Only</h3>
        <p style={{ fontSize: "0.9rem", color: "#666" }}>
          <strong>2.1 No Professional Advice</strong>
          <br />
          The valuation data, estimates, or projections generated by the Service
          are for <strong>informational</strong> and{" "}
          <strong>illustrative</strong> purposes only. They do{" "}
          <strong>not</strong> constitute financial, investment, legal, or tax
          advice.
        </p>
        <p style={{ fontSize: "0.9rem", color: "#666" }}>
          <strong>2.2 Independent Verification</strong>
          <br />
          You agree to independently verify any information you obtain through
          the Service. We strongly recommend consulting qualified professionals
          before making any financial or investment decisions based on the
          valuation results.
        </p>

        <h3>3. User Conduct</h3>
        <p style={{ fontSize: "0.9rem", color: "#666" }}>
          <strong>3.1 Accuracy of Input</strong>
          <br />
          You are responsible for the accuracy and completeness of any data you
          enter into the Service. The Service’s outputs are only as accurate as
          the data provided.
        </p>
        <p style={{ fontSize: "0.9rem", color: "#666" }}>
          <strong>3.2 Prohibited Activities</strong>
          <br />
          You agree not to use the Service for any unlawful purpose, nor to
          attempt to reverse-engineer, misuse, or disrupt the functionality or
          security of the Service.
        </p>

        <h3>4. Disclaimers</h3>
        <p style={{ fontSize: "0.9rem", color: "#666" }}>
          <strong>4.1 “As Is” and “As Available”</strong>
          <br />
          The Service is provided on an “AS IS” and “AS AVAILABLE” basis. We
          <strong> disclaim all warranties</strong>, express or implied,
          including but not limited to implied warranties of merchantability,
          fitness for a particular purpose, and non-infringement.
        </p>
        <p style={{ fontSize: "0.9rem", color: "#666" }}>
          <strong>4.2 No Guarantee of Accuracy</strong>
          <br />
          We do not guarantee the accuracy, reliability, or completeness of any
          valuations, data, or other information provided via the Service.
        </p>
        <p style={{ fontSize: "0.9rem", color: "#666" }}>
          <strong>4.3 Group, Affiliate, and IP Owner Liability</strong>
          <br />
          Any group company, affiliate, intellectual-property owner, licensor,
          or future operating company that is not expressly identified as the
          Service provider for your use of the Service disclaims liability to
          the fullest extent permitted by law. Such entities are not responsible
          for user support, data input, or delivery of any valuation results
          unless they are expressly identified as the Service provider in the
          then-current terms.
        </p>

        <h3>5. Limitation of Liability</h3>
        <p style={{ fontSize: "0.9rem", color: "#666" }}>
          <strong>5.1 Exclusion of Certain Damages</strong>
          <br />
          To the fullest extent permitted by law, in no event shall{" "}
          <strong>DRPY Ltd, Skyward Innovation</strong>, its officers,
          directors, employees, agents, affiliates, licensors, or group entities
          be liable for any{" "}
          <strong>
            indirect, incidental, special, consequential, or exemplary damages
          </strong>
          , including but not limited to damages for loss of profits, goodwill,
          data, or other intangible losses.
        </p>
        <p style={{ fontSize: "0.9rem", color: "#666" }}>
          <strong>5.2 Cap on Liability</strong>
          <br />
          In any event, the total liability of <strong>DRPY Ltd</strong> for all
          claims arising out of or relating to the use or inability to use the
          Service shall not exceed the amount you paid for using the Service (or
          if the Service is free, then EUR 0).
        </p>
        <p style={{ fontSize: "0.9rem", color: "#666" }}>
          <strong>5.3 User Assumption of Risk</strong>
          <br />
          You assume full responsibility for your use of the Service. Any
          reliance you place on the valuation output is strictly at your own
          risk.
        </p>

        <h3>6. Intellectual Property</h3>
        <p style={{ fontSize: "0.9rem", color: "#666" }}>
          <strong>6.1 Ownership</strong>
          <br />
          All software, designs, and other intellectual property used in
          providing the Service are owned or licensed by{" "}
          <strong>DRPY Ltd and/or its licensors</strong>. Nothing in these Terms
          transfers any ownership rights to you.
        </p>
        <p style={{ fontSize: "0.9rem", color: "#666" }}>
          <strong>6.2 License and Restrictions</strong>
          <br />
          You are granted a limited, revocable, non-exclusive license to use the
          Service solely for personal or internal business purposes. You may not
          modify, distribute, copy, or create derivative works of the Service
          without our prior written consent.
        </p>

        <h3>7. Indemnification</h3>
        <p style={{ fontSize: "0.9rem", color: "#666" }}>
          You agree to indemnify and hold harmless{" "}
          <strong>DRPY Ltd, Skyward Innovation</strong>, and their officers,
          directors, employees, agents, affiliates, licensors, and group entities
          from any claims, damages, losses, or expenses arising out of or
          related to your violation of these Terms or misuse of the Service.
        </p>

        <h3>8. Governing Law & Dispute Resolution</h3>
        <p style={{ fontSize: "0.9rem", color: "#666" }}>
          <strong>8.1 Governing Law</strong>
          <br />
          These Terms shall be governed by and construed in accordance with the
          laws of <strong>Ireland</strong>, without regard to conflict of law
          principles.
        </p>
        <p style={{ fontSize: "0.9rem", color: "#666" }}>
          <strong>8.2 Dispute Resolution</strong>
          <br />
          Any disputes arising under or in connection with these Terms shall be
          subject to the exclusive jurisdiction of the courts of{" "}
          <strong>Ireland</strong>.
        </p>

        <h3>9. Changes to the Terms</h3>
        <p style={{ fontSize: "0.9rem", color: "#666" }}>
          We reserve the right to modify these Terms at any time. Changes will
          become effective immediately upon posting. Your continued use of the
          Service after changes are posted constitutes acceptance of the
          modified Terms.
        </p>

        <h3>10. Third-Party Referrals and Services</h3>
        <p style={{ fontSize: "0.9rem", color: "#666" }}>
          <strong>10.1 Referral Relationships</strong>
          <br />
          We may, from time to time, suggest or facilitate introductions to
          third-party service providers (such as drone operators, consultants,
          financial institutions, or brokers). We may receive a referral fee,
          commission, or other compensation from these third-party providers.
        </p>
        <p style={{ fontSize: "0.9rem", color: "#666" }}>
          <strong>10.2 No Endorsement or Warranty</strong>
          <br />
          Any mention of third-party providers is offered merely as a
          convenience. We make no warranty, representation, or guarantee
          regarding their services, and we are not responsible for any dispute
          that may arise between you and such providers.
        </p>
        <p style={{ fontSize: "0.9rem", color: "#666" }}>
          <strong>10.3 Independent Assessment</strong>
          <br />
          You acknowledge that you will independently assess any third-party
          offerings and are solely responsible for your decision to engage (or
          not engage) a third-party provider. All services provided by a
          third-party are subject to that third party’s terms of service,
          privacy policy, and other applicable agreements.
        </p>
        <p style={{ fontSize: "0.9rem", color: "#666" }}>
          <strong>10.4 No Agency</strong>
          <br />
          Nothing in these Terms creates a joint venture, partnership,
          employer-employee, or agency relationship between us and any
          third-party provider. All third-party services are provided by
          independent entities, which are not under our control.
        </p>

        <h3>11. Data Privacy & GDPR</h3>
        <p style={{ fontSize: "0.9rem", color: "#666" }}>
          <strong>11.1 Types of Data Collected</strong>
          <br />
          We collect limited information related to hotel operations and
          property details (e.g., address, occupancy rates, revenue figures) as
          well as an email address for communication. While our Service is
          primarily aimed at businesses, some of this information may be
          considered personal data under certain privacy laws.
        </p>
        <p style={{ fontSize: "0.9rem", color: "#666" }}>
          <strong>11.2 Purpose and Legal Basis</strong>
          <br />
          We process this data to provide valuation estimates, respond to your
          inquiries, and improve our Service. If you are located in the European
          Economic Area (EEA) or another jurisdiction with data protection laws,
          our legal basis for collecting and using personal data may include
          your consent or our legitimate interest in providing and enhancing the
          Service.
        </p>
        <p style={{ fontSize: "0.9rem", color: "#666" }}>
          <strong>11.3 Data Sharing and Transfers</strong>
          <br />
          We do not sell your data to third parties. We may share your
          information with trusted third-party vendors or partners strictly for
          the purpose of assisting with our valuation tools or to facilitate
          third-party services upon your request. If data is transferred outside
          your jurisdiction, we will take steps to ensure adequate protection
          (e.g., EU Standard Contractual Clauses).
        </p>
        <p style={{ fontSize: "0.9rem", color: "#666" }}>
          <strong>11.4 Data Retention</strong>
          <br />
          We retain your data only as long as necessary to fulfill the purposes
          outlined in these Terms or as required by law. If you wish to have
          your data deleted, you may contact us using the contact method below.
        </p>
        <p style={{ fontSize: "0.9rem", color: "#666" }}>
          <strong>11.5 Your Rights</strong>
          <br />
          Depending on your location, you may have the right to request access
          to, correction of, or deletion of your personal data. You may also
          have the right to object to or restrict certain types of data
          processing. To exercise any of these rights, please contact us using
          the contact method below.
        </p>
        <p style={{ fontSize: "0.9rem", color: "#666" }}>
          For more detailed information, please review our full Privacy Policy
          (if applicable) or contact us directly with any questions about data
          handling.
        </p>

        <h3>12. Contact Us</h3>
        <p style={{ fontSize: "0.9rem", color: "#666" }}>
          If you have any questions, concerns, or feedback regarding these Terms
          or the Service, please use the contact button below:
        </p>
        <p style={{ fontSize: "0.9rem", color: "#666" }}>
          <strong>Skyward Innovation</strong>
          <br />
          <button className="button secondary-button" onClick={handleContactClick}>
            Contact by email
          </button>
        </p>

        <hr style={{ margin: "2rem 0" }} />

        <p style={{ fontSize: "0.9rem", color: "#666" }}>
          By using the Service, you acknowledge that you have read, understood,
          and agree to these Terms. We do not provide financial, legal, or tax
          advice. Please consult your professional advisors before relying on
          any valuation results.
        </p>

        <div style={{ marginTop: "40px", textAlign: "center" }}>
          <button className="button" onClick={handleStartValuation}>
            Start Valuation
          </button>
        </div>
      </section>

      {/* Trusted Partners Section */}
      <section
        style={{
          backgroundColor: "#f6f5f0",
          padding: "4px",
          textAlign: "center",
        }}
      >
        <h2 className="section-title">Trusted Partners</h2>
        <div className="partner-container">
          {/* Partner 1 */}
          <a
            href="https://www.partner1website.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/gwwfinal.png" alt="Partner 1" className="partner-logo" />
          </a>
          {/* Partner 2 */}
          <a
            href="https://redrones.ie"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/REDRONES_LOGO2.png"
              alt="Redrones"
              className="partner-logo"
            />
          </a>
          {/* Partner 3 */}
          <a
            href="https://failteabhaile.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/foundation_logo3.png"
              alt="Failteabhaile"
              className="partner-logo"
            />
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer
        style={{
          backgroundColor: "#050d1a",
          color: "#fff",
          padding: "20px",
          textAlign: "center",
        }}
      >
        <p>&copy; 2026 Skyward Innovation. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default TermsOfServiceScreen;
